// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.text-element-editor .v-toolbar__content {\n  padding: 0;\n}\n.text-element-editor .v-btn.v-size--default {\n  min-width: 40px;\n}\n", ""]);
// Exports
module.exports = exports;
